import { render, staticRenderFns } from "./TablaTarifas.vue?vue&type=template&id=f4844e7a"
import script from "./TablaTarifas.vue?vue&type=script&lang=js"
export * from "./TablaTarifas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports